module.exports = __webpack_public_path__ + "static/media/k-logo.ba4f15ce.png";